import React from "react";
import "./styles.css";
import logoTeamViewer from './AsistenciaEnLinea/Logo.png'
import TVexe from './AsistenciaEnLinea/TeamViewerQS_es.exe'
import ERPexe from './AsistenciaEnLinea/InstalarAccesoNube.exe';
import icoSoftwone from './AsistenciaEnLinea/cloud_tyt.png'

export default function AsistenciaEnLineaDescripcion(props) {
    return (
        <>
            <div className="contenedorAsistenciaEnLinea">
                <div className="contenedorContenidoAsistenciaEnLinea">
                    <div className="contenedorDescripcionAsistenciaEnLinea">
                        Los productos de T&T Software de México S.A. de C.V.
                        son intuitivos y fáciles de manejar. No obstante, si
                        tiene algún problema, están a su disposición nuestras
                        completas opciones de soporte. Para tener acceso a
                        ellas, solicite su usuario y contraseña llamando a
                        nuestras oficinas.
                    </div>

                    <div className="contenedorBotonAsistenciaEnLinea">
                        ¿Necesitas soporte? 
                        <div className="botonAsistenciaEnLinea">
                            <a href={TVexe}>
                                <img src={logoTeamViewer} />
                            </a>
                        </div>
                    </div>

                    <div className="contenedorBotonAsistenciaEnLinea">
                        Descarga nuestro instalador 
                        <div className="botonAsistenciaEnLinea">
                            <a href={'https://procesos.tytsoftwaredemexico.com/aXR6bWlu/descargas/AccesoNubeT&T.exe'}>
                                <img src={icoSoftwone} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
